<template>
    <card>
      <template class="card-header" slot="header">
        <h4 class="card-title">
          Usage Information
          <button v-if="!noRefresh" class="btn btn-link text-info pull-right" @click="$emit('refreshData')">
            <font-awesome-icon icon="sync"></font-awesome-icon>
          </button>
        </h4>
        <p class="card-category">Server usage information.</p>
      </template>
      <table class="table table-borderless beast-info-table">
        <tr>
          <th class="beast-key">Uptime:</th>
          <td class="beast-value">{{usageInfo.uptime}}</td>
        </tr>
        <tr>
          <th class="beast-key">Load Average:</th>
          <td class="beast-value">
            {{usageInfo.loadAverage[0].toFixed(2)}} <br/>
            {{usageInfo.loadAverage[1].toFixed(2)}} <br/>
            {{usageInfo.loadAverage[2].toFixed(2)}}
          </td>
        </tr>
        <tr>
          <th class="beast-key">RSS:</th>
          <td class="beast-value">{{usageInfo.memoryUsage.rss}}</td>
        </tr>
        <tr>
          <th class="beast-key">Heap Total:</th>
          <td class="beast-value">{{usageInfo.memoryUsage.heapTotal}}</td>
        </tr>
        <tr>
          <th class="beast-key">Heap Used:</th>
          <td class="beast-value">{{usageInfo.memoryUsage.heapUsed}}</td>
        </tr>
        <tr>
          <th class="beast-key">External:</th>
          <td class="beast-value">{{usageInfo.memoryUsage.external}}</td>
        </tr>
      </table>
    </card>
</template>

<script>
export default {
  props: {
    usageInfo: {
      type: Object,
      required: true
    },
    noRefresh: {
      type: Boolean,
      default: false
    }
  },
  name: "UsageInfo"
};
</script>

<style scoped>

</style>
